import { fetchWrapper } from "../fetchWrapper";
import type {
  LoginRequestBody,
  PasswordChangeRequestBody,
  PasswordResetConfirmRequestBody,
  PasswordResetRequestBody,
  RegistrationRequestBody,
  ResendEmailRequestBody,
  TokenRefreshRequestBody,
  TokenVerifyRequestBody,
  VerifyEmailRequestBody,
} from "./interfaces";

export const Login = async (
  body: LoginRequestBody,
  t?: (key: string, params?: any) => string,
  options?: {
    showToast?: boolean;
    toastMessage?: string;
    toastErrorMessage?: string;
    toastParams?: Record<string, unknown>;
  },
) => {
  const response = await fetchWrapper.post(
    `/auth/login/`,
    body,
    undefined,
    t,
    options,
  );
  return response?._data;
};

export const Logout = async (
  t?: (key: string, params?: any) => string,
  options?: {
    showToast?: boolean;
    toastMessage?: string;
    toastErrorMessage?: string;
    toastParams?: Record<string, unknown>;
  },
) => {
  try {
    const response = await fetchWrapper.post(
      `/auth/logout/`,
      undefined,
      undefined,
      t,
      options,
    );
    return response?._data;
  } catch (error: unknown) {
    console.log(error);
    throw error;
  }
};

export const IsLoggedIn = async (
  t?: (key: string, params?: any) => string,
  options?: {
    showToast?: boolean;
    toastMessage?: string;
    toastErrorMessage?: string;
    toastParams?: Record<string, unknown>;
  },
) => {
  try {
    const apiUrl = useRuntimeConfig().public.apiUrl;
    const response = await fetchWrapper.get(
      `${apiUrl}/user/is_logged_in/`,
      undefined,
      undefined,
      t,
      options,
    );
    return response?._data;
  } catch (error: unknown) {
    console.log(error);
    throw error;
  }
};

export const ChangePassword = async (
  body: PasswordChangeRequestBody,
  t?: (key: string, params?: any) => string,
  options?: {
    showToast?: boolean;
    toastMessage?: string;
    toastErrorMessage?: string;
    toastParams?: Record<string, unknown>;
  },
) => {
  try {
    const response = await fetchWrapper.post(
      `/auth/password/change/`,
      body,
      undefined,
      t,
      options,
    );
    return response?._data;
  } catch (error: unknown) {
    console.log(error);
    throw error;
  }
};

export const ResetPassword = async (
  body: PasswordResetRequestBody,
  t?: (key: string, params?: any) => string,
  options?: {
    showToast?: boolean;
    toastMessage?: string;
    toastErrorMessage?: string;
    toastParams?: Record<string, unknown>;
  },
) => {
  try {
    const response = await fetchWrapper.post(
      `/auth/password/reset/`,
      body,
      undefined,
      t,
      options,
    );
    return response?._data;
  } catch (error: unknown) {
    console.log(error);
    throw error;
  }
};

export const ResetPasswordConfirm = async (
  body: PasswordResetConfirmRequestBody,
  t?: (key: string, params?: any) => string,
  options?: {
    showToast?: boolean;
    toastMessage?: string;
    toastErrorMessage?: string;
    toastParams?: Record<string, unknown>;
  },
) => {
  try {
    const response = await fetchWrapper.post(
      `/auth/password/reset/confirm/`,
      body,
      undefined,
      t,
      options,
    );
    return response?._data;
  } catch (error: unknown) {
    console.log(error);
    throw error;
  }
};

export const Register = async (
  body: RegistrationRequestBody,
  t?: (key: string, params?: any) => string,
  options?: {
    showToast?: boolean;
    toastMessage?: string;
    toastErrorMessage?: string;
    toastParams?: Record<string, unknown>;
  },
) => {
  try {
    const response = await fetchWrapper.post(
      `/be/api/auth/registration/`,
      body,
      undefined,
      t,
      options,
    );
    return response?._data;
  } catch (error: unknown) {
    console.log(error);
    throw error;
  }
};

export const ResendVerificationEmail = async (
  body: ResendEmailRequestBody,
  t?: (key: string, params?: any) => string,
  options?: {
    showToast?: boolean;
    toastMessage?: string;
    toastErrorMessage?: string;
    toastParams?: Record<string, unknown>;
  },
) => {
  try {
    const response = await fetchWrapper.post(
      `/be/api/auth/registration/resend-email/`,
      body,
      undefined,
      t,
      options,
    );
    return response?._data;
  } catch (error: unknown) {
    console.log(error);
    throw error;
  }
};

export const VerifyEmail = async (
  body: VerifyEmailRequestBody,
  t?: (key: string, params?: any) => string,
  options?: {
    showToast?: boolean;
    toastMessage?: string;
    toastErrorMessage?: string;
    toastParams?: Record<string, unknown>;
  },
) => {
  try {
    const response = await fetchWrapper.post(
      `/be/api/auth/registration/verify-email/`,
      body,
      undefined,
      t,
      options,
    );
    return response?._data;
  } catch (error: unknown) {
    console.log(error);
    throw error;
  }
};

export const RefreshToken = async (
  body: TokenRefreshRequestBody,
  t?: (key: string, params?: any) => string,
  options?: {
    showToast?: boolean;
    toastMessage?: string;
    toastErrorMessage?: string;
    toastParams?: Record<string, unknown>;
  },
) => {
  try {
    const response = await fetchWrapper.post(
      `/be/api/auth/token/refresh/`,
      body,
      undefined,
      t,
      options,
    );
    return response?._data;
  } catch (error: unknown) {
    console.log(error);
    throw error;
  }
};

export const VerifyToken = async (
  body: TokenVerifyRequestBody,
  t?: (key: string, params?: any) => string,
  options?: {
    showToast?: boolean;
    toastMessage?: string;
    toastErrorMessage?: string;
    toastParams?: Record<string, unknown>;
  },
) => {
  try {
    const response = await fetchWrapper.post(
      `/be/api/auth/token/verify/`,
      body,
      undefined,
      t,
      options,
    );
    return response?._data;
  } catch (error: unknown) {
    console.log(error);
    throw error;
  }
};
